module.exports = __webpack_public_path__ + "static/media/arrow-up-from-square.6d3a4db7.svg";